import { render, staticRenderFns } from "./DealsLayout.vue?vue&type=template&id=0fdfc46b&scoped=true&"
import script from "./DealsLayout.vue?vue&type=script&lang=js&"
export * from "./DealsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdfc46b",
  null
  
)

export default component.exports